import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { CustomIconsService } from '@services/custom-icons.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'ftp-platform';
  private customIconsService = inject(CustomIconsService);

  constructor() {
    this.customIconsService.initializeIcons();
  }
}
